"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var React = _interopRequireWildcard(require("react"));

var SvgNights = function SvgNights(props) {
  return /*#__PURE__*/React.createElement("svg", (0, _extends2["default"])({
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "m14.524 6.62.49-.102a.5.5 0 0 0-.973-.027l.483.13zM9.379 1.477l.13.483a.5.5 0 0 0-.027-.972l-.103.49zM14.167 8A6.167 6.167 0 0 1 8 14.167v1A7.167 7.167 0 0 0 15.167 8h-1zm-.132-1.276c.086.411.132.838.132 1.276h1c0-.508-.053-1.004-.154-1.482l-.978.206zm.006-.233a3.7 3.7 0 0 1-3.572 2.737v1a4.7 4.7 0 0 0 4.538-3.478l-.966-.259zm-3.572 2.737a3.698 3.698 0 0 1-3.697-3.697h-1a4.698 4.698 0 0 0 4.697 4.697v-1zM6.772 5.531a3.7 3.7 0 0 1 2.737-3.572L9.25.993a4.7 4.7 0 0 0-3.478 4.538h1zM8 1.833c.438 0 .865.046 1.277.132l.205-.978A7.194 7.194 0 0 0 8 .833v1zM1.833 8A6.167 6.167 0 0 1 8 1.833v-1A7.167 7.167 0 0 0 .833 8h1zM8 14.167A6.167 6.167 0 0 1 1.833 8h-1A7.167 7.167 0 0 0 8 15.167v-1z",
    fill: "#17181A"
  }));
};

var Memo = /*#__PURE__*/(0, React.memo)(SvgNights);
var _default = Memo;
exports["default"] = _default;